
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"workItemMetadataEE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fullPath"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fullPath"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fullPath"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"availableFeatures"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkItemAvailableFeatures"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasWorkItemStatusFeature"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"linkPaths"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkItemLinkPaths"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"epicsList"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"labelsFetch"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"issuesSettings"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"epicsListPath"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"userPermissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createWorkItem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createLabel"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gl_introduced"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"StringValue","value":"19.5.0","block":false}}]}]},{"kind":"Field","name":{"kind":"Name","value":"createProjects"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adminIssue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adminProject"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"importWorkItems"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"readCrmContact"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"readCrmOrganization"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createSavedView"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkItemMetadata"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"subscribedSavedViewLimit"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":748}};
    doc.loc.source = {"body":"#import \"~/work_items/graphql/work_item_metadata.fragment.graphql\"\n\n# @feature_category: team_planning\nquery workItemMetadataEE($fullPath: ID!) {\n  namespace(fullPath: $fullPath) {\n    id\n    name\n    availableFeatures {\n      ...WorkItemAvailableFeatures\n      hasWorkItemStatusFeature\n    }\n    linkPaths {\n      ...WorkItemLinkPaths\n      epicsList\n      labelsFetch\n      issuesSettings\n      epicsListPath\n    }\n    userPermissions {\n      createWorkItem\n      createLabel @gl_introduced(version: \"19.5.0\")\n      createProjects\n      adminIssue\n      adminProject\n      importWorkItems\n      readCrmContact\n      readCrmOrganization\n      createSavedView\n    }\n    metadata {\n      ...WorkItemMetadata\n    }\n    subscribedSavedViewLimit\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("~/work_items/graphql/work_item_metadata.fragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["workItemMetadataEE"] = oneQuery(doc, "workItemMetadataEE");
        
